(function () {
  var rootSelector = '[data-tiered-sale]';

  function fallbackCopy(text) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    var copied = document.execCommand('copy');
    document.body.removeChild(textarea);
    if (!copied) throw new Error('Copy command failed');
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    fallbackCopy(text);
    return Promise.resolve();
  }

  function bind(root) {
    if (!root || root.getAttribute('data-tiered-sale-bound') === 'true') return;
    root.setAttribute('data-tiered-sale-bound', 'true');

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-tiered-copy]');
      if (!button || !root.contains(button)) return;

      var code = button.getAttribute('data-tiered-copy');
      var label = button.querySelector('[data-tiered-copy-label]');
      var status = root.querySelector('[data-tiered-status]');

      copyText(code).then(function () {
        if (label) label.textContent = 'Copied';
        if (status) status.textContent = code + ' copied to clipboard.';
        window.setTimeout(function () {
          if (label) label.textContent = 'Copy';
        }, 1800);
      }).catch(function () {
        if (status) status.textContent = 'Copy failed. Select and copy ' + code + '.';
      });
    });
  }

  function bindAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches(rootSelector)) bind(context);
    Array.prototype.forEach.call(context.querySelectorAll(rootSelector), bind);
  }

  bindAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    bindAll(event.target);
  });
})();
